// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-50bb0f90] {\n  color: var(--magic-tertiary, #311261);\n}\n@media (min-width: 1024px) {\n  .label[data-v-50bb0f90] {\n    color: var(--radio-label-color, var(--magic-tertiary, #311261));\n  }\n}", ""]);
// Exports
module.exports = exports;
